import React from 'react';
import Chatbot from '../Components/Chatbot';

const Home = () => {
  return (
    <div style={{ height: '100vh', margin: 0 }}>
      <Chatbot />
    </div>
  );
};

export default Home;
